import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import TeamComp from '../../../../components/Users/UsersComponent';

interface HiringManagerModalProps {
  open: boolean;
  onClose: () => void;
  usersByEnterpriseId: any[];
  adminUser: any;
  userData: any;
  enterpriseData: any;
  selectedEmployer: {
    employerId: number | null;
    employerName?: string;
    employerPic?: string;
    employerInitials?: string;
    employerBgColor?: string;
    employerColor?: string;
  };
  onSelectEmployer: (employer: {
    employerId: number;
    employerName: string;
    employerPic: string;
    employerInitials: string;
    employerBgColor: string;
    employerColor: string;
  }) => void;
}

const HiringManagerModal: React.FC<HiringManagerModalProps> = ({
  open,
  onClose,
  usersByEnterpriseId,
  adminUser,
  userData,
  enterpriseData,
  selectedEmployer,
  onSelectEmployer,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          fontSize: '18px',
          fontWeight: 500,
          textAlign: 'center',
        }}
      >
        Select a Hiring Manager
      </DialogTitle>

      <DialogContent sx={{ paddingBottom: '0px' }}>
        <TeamComp
          teamInfo={usersByEnterpriseId}
          userInfo={adminUser}
          userData={userData}
          enterpriseData={enterpriseData}
          isCreateEditJob={true}
          currentEmployer={selectedEmployer?.employerId ?? null}
          onSelectEmployer={(item) => {
            onSelectEmployer({
              employerName: item?.User_FirstName?.substring(0, 8) ?? '',
              employerId: item?.pk_User_ID,
              employerPic: item?.User_ImageLink ?? '',
              employerInitials: item?.User_Initials ?? '',
              employerBgColor: item?.User_BackgroundColour ?? '',
              employerColor: item?.User_Colour ?? '',
            });
            onClose();
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default HiringManagerModal;
